import ArchiveIcon from './ArchiveIcon';
export default ArchiveIcon;
